<template>
  <div id="nav">
    <div id="nav-lang">
      <span
        class="lang-btns"
        :class="this.$i18n.locale == 'zh' ? 'lang-active' : ''"
        @click.stop="changeLang('zh')"
      >简体中文</span> |
      <span
        class="lang-btns"
        :class="this.$i18n.locale == 'en' ? 'lang-active' : ''"
        @click.stop="changeLang('en')"
      >English</span> |
      <span
        class="lang-btns"
        :class="this.$i18n.locale == 'ja' ? 'lang-active' : ''"
        @click.stop="changeLang('ja')"
      >日本語</span>
    </div>
    <div id="nav-icon">
      <a
        v-for="icon in icons[this.$i18n.locale]"
        :key="icon.alt"
        :href="icon.url"
        target="_blank"
      >
        <img
          :src="icon.icon"
          :alt="icon.alt"
          class="icon-btns"
        >
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      icons: {
        "zh": [
          {
            "alt": "QQ",
            "icon": require("../assets/images/202510/icons/zh/qq.png"),
            "url": "https://pd.qq.com/s/al26pdtoh"
          },
          {
            "alt": "bilibili",
            "icon": require("../assets/images/202510/icons/zh/bilibili.png"),
            "url": "https://space.bilibili.com/1663803541"
          },
          {
            "alt": "小黑盒",
            "icon": require("../assets/images/202510/icons/zh/xiaoheihe.png"),
            "url": "https://www.xiaoheihe.cn/app/topic/game/pc/2273430"
          }
        ],
        "en": [
          {
            "alt": "Youtube",
            "icon": require("../assets/images/202510/icons/en/youtube.png"),
            "url": "https://www.youtube.com/@BBEE_Global"
          },
          {
            "alt": "X",
            "icon": require("../assets/images/202510/icons/en/x.png"),
            "url": "https://x.com/BBEE_Global"
          },
          {
            "alt": "Ins",
            "icon": require("../assets/images/202510/icons/en/instagram.png"),
            "url": "https://www.instagram.com/blazblueentropyeffect"
          },
          {
            "alt": "Bluesky",
            "icon": require("../assets/images/202510/icons/en/bluesky.png"),
            "url": "https://bsky.app/profile/bbee-global.bsky.social"
          }
        ],
        "ja": [
          {
            "alt": "Youtube",
            "icon": require("../assets/images/202510/icons/ja/youtube.png"),
            "url": "https://www.youtube.com/@BBEE_Global"
          },
          {
            "alt": "X",
            "icon": require("../assets/images/202510/icons/ja/x.png"),
            "url": "https://x.com/BBEE_JAPAN"
          },
          {
            "alt": "Ins",
            "icon": require("../assets/images/202510/icons/ja/instagram.png"),
            "url": "https://www.instagram.com/blazblueentropyeffect"
          },
          {
            "alt": "Bluesky",
            "icon": require("../assets/images/202510/icons/ja/bluesky.png"),
            "url": "https://bsky.app/profile/bbee-global.bsky.social"
          }
        ]
      }
    }
  },
  methods: {
    changeLang(lang) {
      this.$i18n.locale = lang
      document.title = this.$i18n.t('meta.base')
    },
  },
  beforeCreate() {
    document.title = this.$i18n.t('meta.base')
  }
}
</script>

<style scoped>
#nav {
  width: 750px;
  height: 88px;
  background-image: url("../assets/images/nav-back.png");
  background-size: 100%;
  background-repeat: no-repeat;
  position: relative;
}

#nav-lang {
  max-width: 300px;
  position: absolute;
  left: 200px;
  top: 30px;
  text-align: center;
  color: #838383;
  font-size: 20px;

  font-family: "MiSans-Bold";
}

.lang-btns {
  margin: 0 8px;
}

.lang-btns:last-child {
  margin-right: 0;
}

.lang-active {
  color: white;
}

#nav-icon {
  position: absolute;
  right: 10px;
  top: 20px;
}

.icon-btns {
  width: 42px;
  height: 42px;
  padding: 0 7px;
}
</style>
